import { useMutation, useQueryClient } from '@tanstack/react-query';
import { sendFriendRecommendation, type SendFriendRecommendationParams } from '@/api/endpoints/friend-recommendation';
import { FRIEND_RECOMMENDATION_QUERY_KEYS } from '@/api/queries/friend-recommendation';

export function useRecommendToFriend() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: SendFriendRecommendationParams) => sendFriendRecommendation(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: FRIEND_RECOMMENDATION_QUERY_KEYS.all });
    },
  });
}
